import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { datasetQueryKeys } from "./useDatasetsQuery";

export function useDatasetTags(orgId?: string) {
  const { currentOrganization } = useAuth();
  const canonicalOrgId = orgId || currentOrganization?.org_id;
  const { datasetService } = useDomainServices();

  return useQuery<string[], Error>({
    // `enabled` below gates the fetch, so the empty-string key is never run.
    queryKey: datasetQueryKeys.orgTags(canonicalOrgId ?? ""),
    queryFn: ({ signal }) => {
      if (canonicalOrgId === undefined) {
        return Promise.reject(new Error("Invalid orgId"));
      }

      // Callers needing truncation info call the service directly.
      return datasetService
        .getTagsForOrg(
          {},
          {
            abortSignal: signal,
            resourceOwnerId: canonicalOrgId,
          },
        )
        .then((page) => page.items);
    },
    enabled: canonicalOrgId !== undefined,
  });
}
